// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agent--filter[data-v-3d485f84]{display:flex;align-items:center;margin-bottom:24px}.agent--filter .input--wrapper[data-v-3d485f84]{width:400px}", ""]);
// Exports
module.exports = exports;
